<template>
    <div class="h-8 flex-1 rounded border-2 border-green-500 bg-gray-900/75 backdrop-blur-sm"></div>
</template>
